
import { Vue, Component } from 'vue-property-decorator'
import ConstructionWorker from '@/types/constructionWorker'
import ConstructionWorkerEditDetailsTab from '@/views/constructionWorker/tabs/edit/ConstructionWorkerEditDetailsTab.vue'
import ls from '@/ls'

@Component({
  components: { ConstructionWorkerEditDetailsTab }
})

export default class ConstructionWorkerEdit extends Vue {
  settings = {
    routeNames: { list: 'constructionWorkers', show: 'constructionWorkerShow', edit: 'constructionWorkerEdit' },
    routeParamKey: 'constructionWorkerId',
    functionNames: { setCurrent: 'setCurrentConstructionWorker', clearCurrent: 'clearCurrentConstructionWorker', save: 'saveConstructionWorker' },
    getterNames: { current: 'currentConstructionWorker', loading: 'loadingConstructionWorker' }
  }

  currentTab:string = ls.get('constructionWorkerEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('constructionWorkerEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, id:number|undefined) : void {
    if (id) {
      this.$router.push({ name: routeName, params: { companyId: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : ConstructionWorker {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
